export default __webpack_public_path__ + "static/media/lunch_dining.252c7015.svg";